import { $ as $E, html, type Html, Page } from 'rune-ts';
import klass from './GoodsPartnerLanding.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';
import { BaseLayoutOptions } from '@services/MarppleShop/features/Core/service';
import { footer_links } from '@services/MarppleShop/renderApp/components/cells/Footer/constant.ts';
import { MainSection } from '@services/MarppleShop/renderApp/pages/GoodsPartnerLanding/views/MainSection';
import { BottomSection } from '@services/MarppleShop/renderApp/pages/GoodsPartnerLanding/views/BottomSection';
import { BusinessSection } from '@services/MarppleShop/renderApp/pages/GoodsPartnerLanding/views/BusinessSection';
import { ServiceSection } from '@services/MarppleShop/renderApp/pages/GoodsPartnerLanding/views/ServiceSection';
import { ProductSection } from '@services/MarppleShop/renderApp/pages/GoodsPartnerLanding/views/ProductSection';
import { CommunitySection } from '@services/MarppleShop/renderApp/pages/GoodsPartnerLanding/views/CommunitySection';
import { FaqSection } from '@services/MarppleShop/renderApp/pages/GoodsPartnerLanding/views/FaqSection';
import { YoutubeSection } from '@services/MarppleShop/renderApp/pages/GoodsPartnerLanding/views/YoutubeSection';
import { IndexSection } from '@services/MarppleShop/renderApp/pages/GoodsPartnerLanding/views/IndexSection';
import { MarketingSection } from '@services/MarppleShop/renderApp/pages/GoodsPartnerLanding/views/MarketingSection';
import {
  GoodsPartnerHeader,
  navigateChapter,
} from '@services/MarppleShop/renderApp/pages/GoodsPartnerLanding/views/Header';
import { isFixedElementInSection } from '@services/MarppleShop/shared/util/elementPositionHelper.ts';

export type GoodsPartnerLandingPageData = {
  layout_options: BaseLayoutOptions;
};

export class GoodsPartnerLandingPage extends Page<GoodsPartnerLandingPageData> {
  headerSection = new GoodsPartnerHeader();
  mainSection = new MainSection();
  indexSection = new IndexSection();
  productSection = new ProductSection();
  serviceSection = new ServiceSection();
  youtubeSection = new YoutubeSection();
  marketingSection = new MarketingSection();
  communitySection = new CommunitySection();
  businessSection = new BusinessSection();
  bottomSection = new BottomSection();
  faqSection = new FaqSection({ is_mobile: this.data.layout_options.is_mobile });

  protected override template(): Html {
    const { layout_options } = this.data;
    const { is_mobile } = layout_options;

    const body = html`
      <div class="${klass.page}">
        <!--  헤더      -->
        ${this.headerSection}

        <!--  메인 섹션  -->
        ${this.mainSection}

        <!--  목차 섹션  -->
        ${this.indexSection}

        <!--  상품 섹션  -->
        ${this.productSection}

        <!--  서비스 섹션  -->
        ${this.serviceSection}

        <!--  유튜브 쇼핑 섹션  -->
        ${this.youtubeSection}

        <!--  마케팅 섹션      -->
        ${this.marketingSection}

        <!--  멤버십, 후원, 펀딩 섹션  -->
        ${this.communitySection}

        <!--  파트너 기업 섹션  -->
        ${this.businessSection}

        <!--  하단 섹션  -->
        ${this.bottomSection}

        <!--  FAQ 섹션  -->
        ${this.faqSection}
      </div>
    `;

    return html`
      <div class="${klass.page}">
        ${new LayoutView(
          {
            body,
            footer_data: { ...footer_links, lang: ET.lang, is_mobile },
          },
          {
            require_top_arrow_button: false,
            full_width: true,
            has_bottom_tab_bar: false,
            selected_bottom_tab_idx: -1,
            ...layout_options,
          },
        )}
      </div>
    `;
  }

  private handleScrollChangeHeaderColor() {
    if (this.headerSection.isRendered()) {
      const $current_section = $E(this.element())
        .findAll(`.${klass.page} > section`)
        .find(($section) => isFixedElementInSection(this.headerSection.element(), $section.element()));

      if ($current_section) {
        switch ($current_section.element()) {
          case this.mainSection.element():
          case this.businessSection.element():
          case this.bottomSection.element():
            this.headerSection.setThemeColor('white');
            break;
          default:
            this.headerSection.setThemeColor('blue');
            break;
        }
      }
    }
  }

  private handleScrollChangeIndexColor(e: navigateChapter) {
    const target_section = e.detail.target_section;
    let targetEl;

    switch (target_section) {
      case 'goods':
        targetEl = this.productSection.element();
        break;
      case 'youtube':
        targetEl = this.youtubeSection.element();
        break;
      case 'marketing':
        targetEl = this.marketingSection.element();
        break;
      case 'faq':
        targetEl = this.faqSection.element();
        break;
      default:
        break;
    }

    if (targetEl) {
      targetEl.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }

  override onRender() {
    this.handleScrollChangeHeaderColor();
    document.addEventListener('scroll', () => this.handleScrollChangeHeaderColor(), {
      passive: true,
    });

    this.addEventListener(navigateChapter, this.handleScrollChangeIndexColor);
  }
}
